import common from '@namespace/common/index'
import top from '@namespace/top/index'
import voice from '@namespace/voice/index'
// import contact from '@namespace/contact/index'

common()
top()
voice()
// contact()
